<template>
  <div class="container">
    <van-tabs class="top-bar" v-model="active" @change="bindChange">
      <van-tab
        v-for="(item, index) in tabData"
        :key="index"
        :title="item.title"
      ></van-tab>
    </van-tabs>
    <div class="bottom">
      <!--   <van-notice-bar class="notice-bar" scrollable text="今日数据暂未上传，请提醒运营小伙伴上传~" /> -->
      <div
        class="b-item"
        v-show="active == index"
        v-for="(item, index) in tabData"
        :key="index"
      >
        <PageItem v-if="item.data" :data="item" :index="index" />
        <AppLoading class="app-loading" v-else />
      </div>
    </div>
  </div>
</template>
<script>
import AppLoading from '@/components/app/loading/loading.vue'
import PageItem from './components/page.vue'
export default {
  provide() {
    return {
      time: () => this.time
    }
  },
  components: {
    PageItem,
    AppLoading
  },
  data() {
    return {
      tabData: [
        {
          title: '按日',
          id: 1,
          type: 'day',
          httpMethod: 'dailyChart',
          data: null
        },
        {
          title: '按周',
          id: 2,
          type: 'week',
          httpMethod: 'weeklyChart',
          data: null
        },
        {
          title: '按月',
          id: 3,
          type: 'month',
          httpMethod: 'monthlyChart',
          data: null
        }
      ],
      percentData: {
        todayRegisterRate: '当日新增注册率',
        nextDayRetainRate: '次日留存率',
        incomingRate: '进线添加率',
        conversionRate: '添加转化率',
        progressRate: '进行中打卡率',
        activeRate: '活跃打卡率',
        newUserFollowEatRate: '新用户开启跟吃率',
        followEatUv: '跟吃',
        todayEatUv: '今天吃什么',
        ingredientUv: '配料解读',
        heatUv: '热量查询',
        dietCalculatorUv: '饮食计算器',
        fatRecipeUv: '减脂菜谱',
        waterClockUv: '喝水提醒',
        starUv: '星座减脂',
        physicalUv: '体型测评',
        shopUv: '商城专题',
        meUv: '我的记录'
      },
      active: 0,
      time: ''
    }
  },
  created() {
    this.getData()
  },
  methods: {
    bindChange() {
      if (!this.tabData[this.active].data) {
        this.getData(this.active)
      }
    },
    getData(active) {
      active = active || 0
      let params = {
        day_type: this.tabData[active].id
      }
      this.$http
        .getApp('member/DailyData/getOperateKanBan', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.tabData[active].data = this.dealData(res.data)
            this.time = +res.time - 24 * 60 * 60
          } else {
            this.$toast(res.msg)
          }
        })
    },
    dealData(data) {
      data.map((item) => {
        item.dataList.map((item1, index1) => {
          if (
            item1.yesterdayVal !== null &&
            item1.yesterdayVal !== undefined &&
            this.percentData[item1.key]
          ) {
            item1.yesterdayVal = item1.yesterdayVal + '%'
          }
          if (
            item1.currPeriodVal !== null &&
            item1.currPeriodVal !== undefined &&
            this.percentData[item1.key]
          ) {
            item1.currPeriodVal = item1.currPeriodVal + '%'
          }
          if (
            item1.lastPeriodVal !== null &&
            item1.lastPeriodVal !== undefined &&
            this.percentData[item1.key]
          ) {
            item1.lastPeriodVal = item1.lastPeriodVal + '%'
          }
          if (index1 == 0) {
            item1.loaded = true
          } else {
            item1.loaded = false
          }
        })
      })
      return data
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f9f9f9;

  .top-bar {
    ::v-deep .van-tabs__nav {
      background: rgb(45, 122, 252);
    }

    ::v-deep .van-tab {
      color: rgba(255, 255, 255, 0.8);
    }

    ::v-deep .van-tab--active {
      font-size: 16px;
      color: #fff;
    }

    ::v-deep .van-tabs__line {
      width: 80px;
      background: #f48924;
    }
  }

  .bottom {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    position: relative;
    .notice-bar {
      position: absolute;
      left: 0;
      width: 100%;
      top: 0;
      z-index: 99;
    }

    .b-item {
      position: relative;
      height: 100%;
      .app-loading {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}
</style>
